import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';

import { HBox } from '../../../components/Box';

import { Loader } from '../../../components/Loader';

const Container = styled.div`
  font-size: 14px;

  .cell:first-child {
    text-transform: capitalize;
  }
`;

const STATE = {};

/* eslint-disable react/prefer-stateless-function */
class VehicleCMRListItemComp extends BaseComponent {
  constructor(props) {
    super(props, {
      ...STATE,
    });
  }

  componentDidMount() {}

  render() {
    const { vehicle } = this.props;
    if (this.props.work && !this.props.vehicle?.id) return <Loader small />;
    return (
      <Container>
        <HBox vCenter>
          <strong>{vehicle?.vin}</strong>
          <p>
            <span>{`${vehicle?.brand_name}`}&nbsp;</span>
            <span>{`${vehicle?.model_name}`}</span>
          </p>
        </HBox>
      </Container>
    );
  }
}

VehicleCMRListItemComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) => createStructuredSelector({});

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const VehicleCMRListItem = compose(withConnect, withRouter)(VehicleCMRListItemComp);
